import React from 'react'

export default function ArrowHitsTargetIcon({ className = '' }) {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30 0C26.0603 0 22.1593 0.775973 18.5195 2.28361C14.8797 3.79126 11.5726 6.00104 8.7868 8.7868C3.16071 14.4129 0 22.0435 0 30C0 37.9565 3.16071 45.5871 8.7868 51.2132C11.5726 53.999 14.8797 56.2088 18.5195 57.7164C22.1593 59.224 26.0603 60 30 60C37.9565 60 45.5871 56.8393 51.2132 51.2132C56.8393 45.5871 60 37.9565 60 30C60 26.52 59.37 23.07 58.17 19.83L53.37 24.63C53.79 26.4 54 28.2 54 30C54 36.3652 51.4714 42.4697 46.9706 46.9706C42.4697 51.4714 36.3652 54 30 54C23.6348 54 17.5303 51.4714 13.0294 46.9706C8.52856 42.4697 6 36.3652 6 30C6 23.6348 8.52856 17.5303 13.0294 13.0294C17.5303 8.52856 23.6348 6 30 6C31.8 6 33.6 6.21 35.37 6.63L40.2 1.8C36.93 0.63 33.48 0 30 0ZM30 12C25.2261 12 20.6477 13.8964 17.2721 17.2721C13.8964 20.6477 12 25.2261 12 30C12 34.7739 13.8964 39.3523 17.2721 42.7279C20.6477 46.1036 25.2261 48 30 48C34.7739 48 39.3523 46.1036 42.7279 42.7279C46.1036 39.3523 48 34.7739 48 30H42C42 33.1826 40.7357 36.2348 38.4853 38.4853C36.2348 40.7357 33.1826 42 30 42C26.8174 42 23.7652 40.7357 21.5147 38.4853C19.2643 36.2348 18 33.1826 18 30C18 26.8174 19.2643 23.7652 21.5147 21.5147C23.7652 19.2643 26.8174 18 30 18V12Z"
        fill="black"
      />
      <path
        d="M51 0L39 12V16.5L31.35 24.15C30.9 24 30.45 24 30 24C28.4087 24 26.8826 24.6321 25.7574 25.7574C24.6321 26.8826 24 28.4087 24 30C24 31.5913 24.6321 33.1174 25.7574 34.2426C26.8826 35.3679 28.4087 36 30 36C31.5913 36 33.1174 35.3679 34.2426 34.2426C35.3679 33.1174 36 31.5913 36 30C36 29.55 36 29.1 35.85 28.65L43.5 21H48L60 9H51V0Z"
        fill="url(#paint0_linear_20872_99331)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_20872_99331"
          x1="24"
          y1="0"
          x2="67.4546"
          y2="18.2551"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#52B4F9" />
          <stop offset="1" stopColor="#8400F7" />
        </linearGradient>
      </defs>
    </svg>
  )
}
